// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Listeners from './1-listeners.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';


// local variables ------------------------------------------------------------
let view = 'program';
let filter = 'all';

// program function ---------------------------------------------------------------
export const initProgram = ()=> {
  // touch and mouse --------------------------------
  document.body.addEventListener('click', event => { // triggers on tap, not on move
    let el = Listeners.elFromEvent('.filters__button', event);
    if (el) {
      if (el.classList.contains('filters__button--parent')) {
        if (!el.classList.contains('filters__button--parent--active')) {
          document.querySelectorAll('.filters__button').forEach(filtersButtonEl => {
            filtersButtonEl.classList.remove('button--active');
          });

          const filtersBtnAllEl = document.querySelector('.filters__button[data-filter="all"]');
          if (filtersBtnAllEl) filtersBtnAllEl.classList.add('button--active');

          filter = 'all';
          setFilter();
        }
      } else {
        if (!el.classList.contains('filters__button--sub')) {
          const activeParentEls = document.querySelectorAll('.filters__button--parent--active');
          activeParentEls.forEach(activeParentEl => {
            activeParentEl.click();
          });
        }

        document.querySelectorAll('.filters__button').forEach(filtersButtonEl => {
          filtersButtonEl.classList.remove('button--active');
        });

        el.classList.add('button--active');

        filter = el.getAttribute('data-filter');
        setFilter();
      }
    }

    // view button
    el = Listeners.elFromEvent('.filters__view', event);
    if (el) {
      if (el.classList.contains('filters__view--active')) return;
      Listeners.disableSound(); 

      document.querySelectorAll('.filters__view').forEach(filtersViewEl => {
        filtersViewEl.classList.remove('filters__view--active');
      });
      el.classList.add('filters__view--active');

      const programEl = document.querySelector('.program');
      const programListEl = document.querySelector('.program-list');

      // console.log({programEl, programListEl});

      if(!programEl || !programListEl) return;

      programEl.classList.add('program--faded');
      programListEl.classList.add('program-list--faded');

      view = el.getAttribute('data-view');
      Scroll.scrollAboveFooter(switchProgramView);
    };
  });
  
  // mouse and keyboard --------------------------------
  // mouseout, focusout listeners 
  const outHandler = event => {
    // use if (event.type === 'mouseout') to avoid keyboard blur
    if (Vars.blTouch) return;
    if (event.type === 'focusout' && !Listeners.fromKeyboard) return;

    let el = Listeners.elFromEvent('.program-list-item__name-holder', event);
    if (el){
      let programImageEl = document.querySelector('.program-image');
      if (!programImageEl) return;

      programImageEl.classList.remove('program-image--active');
    }
  };

  // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button

  const inHandler = event => {
    // use if (event.type === 'mouseover') to avoid keyboard focus
    if (Vars.blTouch) return;
    if (event.type === 'focusin' && !Listeners.fromKeyboard) return;
    // console.log('inHandler', event.target.classList[0], event.type);

    let el = Listeners.elFromEvent('.program-list-item__name-holder', event);
    if (el){
      const programImageEl = document.querySelector('.program-image');
      const nr = el.dataset.nr;
      const listItemEl = el.closest('.program-list-item');
      const imgEl = document.querySelector('.program-image__image');
      const itemImageEl = listItemEl.querySelector('.program-list-item__image--' + nr);
      if (!programImageEl || !imgEl || !itemImageEl) return;

      imgEl.setAttribute('src', '');
      imgEl.setAttribute('srcset', '');

      let src = itemImageEl.getAttribute('data-src');
      let srcset = itemImageEl.getAttribute('data-srcset');

      // console.log({src, srcset});

      imgEl.setAttribute('src', src);
      imgEl.setAttribute('srcset', srcset);

      programImageEl.classList.add('program-image--active');

      const rect = el.getBoundingClientRect();
      let xCenter = rect.left + (rect.width / 2);
      let yCenter = rect.top + (rect.height / 2);

      if (yCenter < Resize.windowHeight / 2) {
        programImageEl.classList.add('program-image--bottom');
      } else {
        programImageEl.classList.remove('program-image--bottom');
      }

      if (xCenter < 220) {
        xCenter = 220;
      } else if (xCenter > Resize.windowWidth - 220) {
        xCenter = Resize.windowWidth - 220;
      }

      programImageEl.style.top = (yCenter + Scroll.scrollTop) + 'px';
      programImageEl.style.left = xCenter + 'px';
    }
  };

  // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button
}

const switchProgramView = () => {
  const programEl = document.querySelector('.program');
  const programListEl = document.querySelector('.program-list');

  if(!programEl || !programListEl) return;

  if (view === 'program') {
    programEl.classList.remove('program--hidden');
    programListEl.classList.add('program-list--hidden');

    setTimeout(() => {
      programEl.classList.remove('program--faded');
      Once.fader.fadeInHolderAgain('.program');
    }, 100);
  } else {
    programListEl.classList.remove('program-list--hidden');
    programEl.classList.add('program--hidden');

    setTimeout(() => {
      programListEl.classList.remove('program-list--faded');
    }, 100);
  }

  setScrollToTop();
};

// functions -------------------------------------------------------------------
const setFilter = () =>{
  Listeners.disableSound();

  const programEl = document.querySelector('.program');
  const programListEl = document.querySelector('.program-list');

  if(!programEl || !programListEl) return;

  programEl.classList.add('program--faded');
  programListEl.classList.add('program-list--faded');

  Scroll.scrollAboveFooter(switchFilter);
}

const switchFilter = () => {
  const programEl = document.querySelector('.program');
  const programListEl = document.querySelector('.program-list');

  if(!programEl || !programListEl) return;

  const programItemEls = document.querySelectorAll('.program-item');
  const programListItemEls = document.querySelectorAll('.program-list-item');

  if (filter == 'all') {
    programItemEls.forEach(programItemEl => {
      programItemEl.classList.remove('program-item--hidden');
    });

    programListItemEls.forEach(programListItemEl => {
      programListItemEl.classList.remove('program-list-item--hidden');
      programListItemEl.classList.remove('program-list-item--dot-hidden');
    });
  } else {
    programItemEls.forEach(programItemEl => {
      programItemEl.classList.add('program-item--hidden');
    });

    programListItemEls.forEach(programListItemEl => {
      programListItemEl.classList.add('program-list-item--hidden');
    });

    const filteredProgramItemEls = document.querySelectorAll('.program-item[data-terms~="' + filter + '"]');
    filteredProgramItemEls.forEach(filteredProgramItemEl => {
      filteredProgramItemEl.classList.remove('program-item--hidden');
    });

    const filteredProgramListItemEls = document.querySelectorAll('.program-list-item[data-terms~="' + filter + '"]');

    filteredProgramListItemEls.forEach(filteredProgramListItemEl => {
      filteredProgramListItemEl.classList.remove('program-list-item--hidden');
    });

    const lastFilteredProgramListItemEl = filteredProgramListItemEls[filteredProgramListItemEls.length - 1];
    if (lastFilteredProgramListItemEl) lastFilteredProgramListItemEl.classList.add('program-list-item--dot-hidden');
  }

  programEl.classList.remove('program--faded');
  programListEl.classList.remove('program-list--faded');

  Once.fader.fadeInHolderAgain('.program');

  setScrollToTop(); 
}

const setScrollToTop = () => {
  const topEl = document.querySelector('#program-top');
  if (!topEl) return;

  const rect = topEl.getBoundingClientRect();
  const top = rect.top + Scroll.scrollTop - Resize.headerHeight;
  
  if (Scroll.scrollTop > top) {
    Once.animator.setScrollPosHard({ pos: top });
  }
}
